(() => {
  const supportsTTS = () => "speechSynthesis" in window && "SpeechSynthesisUtterance" in window;

  const cleanText = (root) => {
    // Grab readable text, avoid nav/footer junk by using your content wrapper
    let text = root.innerText || root.textContent || "";
    // Light cleanup
    text = text.replace(/\s+/g, " ").trim();
    return text;
  };

  const initTTS = (container) => {
    const btn = container.querySelector("[data-tts-toggle]");
    const voiceSelect = container.querySelector("[data-tts-voice]");
    const rateInput = container.querySelector("[data-tts-rate]");
    const content = document.querySelector("[data-tts-content]");

    if (!btn || !voiceSelect || !rateInput || !content) return;

    if (!supportsTTS()) {
      container.classList.add("rr-tts--hidden");
      return;
    }

    let voices = [];
    let utterance = null;
    let isSpeaking = false;
    let isPaused = false;

    const setButton = (state) => {
      // state: "idle" | "speaking" | "paused"
      if (state === "idle") {
        btn.textContent = "▶ Listen";
        btn.setAttribute("aria-pressed", "false");
      } else if (state === "speaking") {
        btn.textContent = "⏸ Pause";
        btn.setAttribute("aria-pressed", "true");
      } else {
        btn.textContent = "▶ Resume";
        btn.setAttribute("aria-pressed", "true");
      }
    };

    const loadVoices = () => {
      voices = window.speechSynthesis.getVoices() || [];
      voiceSelect.innerHTML = "";

      // Prefer English voices first
      const sorted = [...voices].sort((a, b) => {
        const aEn = (a.lang || "").toLowerCase().startsWith("en");
        const bEn = (b.lang || "").toLowerCase().startsWith("en");
        return Number(bEn) - Number(aEn);
      });

      sorted.forEach((v, idx) => {
        const opt = document.createElement("option");
        opt.value = String(idx);
        opt.textContent = `${v.name} (${v.lang})`;
        voiceSelect.appendChild(opt);
      });

      // Default to first English if available
      const firstEnglishIndex = sorted.findIndex(v => (v.lang || "").toLowerCase().startsWith("en"));
      voiceSelect.value = String(Math.max(firstEnglishIndex, 0));
    };

    const stop = () => {
      window.speechSynthesis.cancel();
      utterance = null;
      isSpeaking = false;
      isPaused = false;
      setButton("idle");
    };

    const speak = () => {
      stop();

      const text = cleanText(content);
      if (!text) return;

      utterance = new SpeechSynthesisUtterance(text);

      const selectedIndex = parseInt(voiceSelect.value || "0", 10);
      const selectedVoice = (window.speechSynthesis.getVoices() || [])[selectedIndex];
      if (selectedVoice) utterance.voice = selectedVoice;

      utterance.rate = parseFloat(rateInput.value || "1");

      utterance.onend = () => stop();
      utterance.onerror = () => stop();

      window.speechSynthesis.speak(utterance);
      isSpeaking = true;
      isPaused = false;
      setButton("speaking");
    };

    const pause = () => {
      if (!isSpeaking) return;
      window.speechSynthesis.pause();
      isPaused = true;
      setButton("paused");
    };

    const resume = () => {
      if (!isSpeaking) return;
      window.speechSynthesis.resume();
      isPaused = false;
      setButton("speaking");
    };

    btn.addEventListener("click", () => {
      // If not speaking, start.
      if (!isSpeaking) return speak();
      // If speaking, toggle pause/resume.
      if (isPaused) return resume();
      return pause();
    });

    // If user changes voice/rate mid-speech, restart cleanly
    voiceSelect.addEventListener("change", () => {
      if (isSpeaking) speak();
    });
    rateInput.addEventListener("change", () => {
      if (isSpeaking) speak();
    });

    // Voices load async in many browsers
    loadVoices();
    window.speechSynthesis.onvoiceschanged = loadVoices;

    // Stop if user navigates away or hides tab
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) stop();
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-tts]").forEach(initTTS);
  });
})();